import React from 'react';
import { Col, Layout, Row } from 'antd';
import { Link } from 'react-router-dom';
import { useAppContext } from '../../contexts/AppContext';
import { Div } from '../_base/style';
import { AppLogo, AppName } from '@/config';
import AuthInfo from '../_base/UserInfo';

interface BaseProps {
  children?: any;
}
const { Header, Content } = Layout;

const NoMenuLayout = React.memo((props: BaseProps) => {
  const { theme } = useAppContext();
  //

  //
  const { darkMode, rtl, topMenu } = theme;
  return (
    <Div darkMode={darkMode}>
      <Layout className="layout">
        <Header
          className="app-header"
          style={{
            position: 'fixed',
            width: '100%',
            top: 0,
            [!rtl ? 'left' : 'right']: 0,
          }}
        >
          <Row>
            <Col lg={8} xl={4} md={16} sm={12} xs={12} className={`align-center-v navbar-brand ${topMenu ? 'justify-content-center' : ''}`}>
              <Link className="striking-logo" to="/" style={{ display: 'flex', marginLeft: 10, flexDirection: 'row', alignItems: 'center' }}>
                <AppLogo style={{ marginRight: 10, height: 30 }} />
                <span style={{ color: '#0a8ca3', fontSize: 26, textTransform: 'uppercase', fontWeight: 'bold' }}>{AppName}</span>
              </Link>
            </Col>
            <Col lg={10} xl={14} md={0} sm={0} xs={0}></Col>
            <Col lg={6} xl={6} md={8} sm={12} xs={12}>
              <AuthInfo />
            </Col>
          </Row>
        </Header>

        <Layout>
          <Layout className={`atbd-main-layout has-top-menu`} style={{ marginLeft: 0 }}>
            <Content>
              <div style={{ minHeight: 'calc(100vh - 75px)', backgroundColor: '#f8f8f8', marginLeft: 10, marginTop: 10 }}>{props.children}</div>
            </Content>
          </Layout>
        </Layout>
      </Layout>
    </Div>
  );
});

export default NoMenuLayout;
